import { createContext } from 'react';

import {
  BouncedEmailDetails,
  StepResult,
} from '@totem/components/administration/bouncedEmails/details/types';
import { BouncedEmailContact } from '@totem/components/administration/bouncedEmails/types';

interface Context {
  loading: boolean;
  working: boolean;
  details: BouncedEmailDetails | null;
  onRefresh: () => void;
  setStatus: (status: string) => void;
  removeContact: (contact: BouncedEmailContact) => void;
  disableUser: () => void;
  disableRemoteAccess: () => void;
  lastSteps: StepResult[];
}

export default createContext<Context>({
  loading: false,
  working: false,
  details: null,
  onRefresh: () => {},
  setStatus: () => {},
  removeContact: () => {},
  disableUser: () => {},
  disableRemoteAccess: () => {},
  lastSteps: [],
});
